export default "__VITE_PUBLIC_ASSET__36f20f7b__"